/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateLogin = /* GraphQL */ `
  subscription OnCreateLogin($filter: ModelSubscriptionLoginFilterInput) {
    onCreateLogin(filter: $filter) {
      id
      Email
      Password
      LoginDate
      LoginTime
      ProfileType
      GeneralInformation {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLogin = /* GraphQL */ `
  subscription OnUpdateLogin($filter: ModelSubscriptionLoginFilterInput) {
    onUpdateLogin(filter: $filter) {
      id
      Email
      Password
      LoginDate
      LoginTime
      ProfileType
      GeneralInformation {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLogin = /* GraphQL */ `
  subscription OnDeleteLogin($filter: ModelSubscriptionLoginFilterInput) {
    onDeleteLogin(filter: $filter) {
      id
      Email
      Password
      LoginDate
      LoginTime
      ProfileType
      GeneralInformation {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCreatePlan = /* GraphQL */ `
  subscription OnCreateCreatePlan(
    $filter: ModelSubscriptionCreatePlanFilterInput
    $userId: String
    $organizationId: String
  ) {
    onCreateCreatePlan(
      filter: $filter
      userId: $userId
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      PSProblemSolving
      PSSelfEsteem
      PSChoiceAutonomy
      PSSelfCare
      PSSelfAwareness
      PSCreativity
      CSForgiveness
      CSKindness
      CSGratitude
      CSPatience
      CSCourage
      CMSCopingChoice
      CMSResilience
      CMSSelfRegulation
      CMSOptimism
      COMSupportSystem
      COMSocialIntelligence
      COMCommunication
      COMFaithCommunity
      COMAccomplishments
      BRStableHousing
      BRQualityHealthcare
      BRProfessionalAccess
      BRInsuranceCoverage
      BRFinancialConstraints
      BREducationAttainment
      BRSocialStigma
      BRUnsupportiveCommunity
      BRNonexistentCommunity
      BRCommunityResources
      BRProfessionalTrust
      BRHealthcareSystemTrust
      BRCognitiveImpairments
      BRDependentCare
      BRTransportation
      BRTechnologyAccess
      BRLanguage
      BRHealthcareProcess
      BROther
      BRResponseNote
      TGBetrayal
      TGBoundaries
      TGDisorder
      TGPain
      TGRejection
      TGStress
      TGMemories
      TGUnjustTreatment
      TGUnpleasantConversations
      TGUnsafeEnvironments
      TGOther
      WSFlashbacks
      WSIncreasedAppetite
      WSDecreasedAppetite
      WSIntenseEmotions
      WSDisconnecting
      WSTime
      WSNegativeSelfTalk
      WSNeglectingSelfCare
      WSNightmares
      WSRecklessBehavior
      WSOther
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCreatePlan = /* GraphQL */ `
  subscription OnUpdateCreatePlan(
    $filter: ModelSubscriptionCreatePlanFilterInput
    $userId: String
    $organizationId: String
  ) {
    onUpdateCreatePlan(
      filter: $filter
      userId: $userId
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      PSProblemSolving
      PSSelfEsteem
      PSChoiceAutonomy
      PSSelfCare
      PSSelfAwareness
      PSCreativity
      CSForgiveness
      CSKindness
      CSGratitude
      CSPatience
      CSCourage
      CMSCopingChoice
      CMSResilience
      CMSSelfRegulation
      CMSOptimism
      COMSupportSystem
      COMSocialIntelligence
      COMCommunication
      COMFaithCommunity
      COMAccomplishments
      BRStableHousing
      BRQualityHealthcare
      BRProfessionalAccess
      BRInsuranceCoverage
      BRFinancialConstraints
      BREducationAttainment
      BRSocialStigma
      BRUnsupportiveCommunity
      BRNonexistentCommunity
      BRCommunityResources
      BRProfessionalTrust
      BRHealthcareSystemTrust
      BRCognitiveImpairments
      BRDependentCare
      BRTransportation
      BRTechnologyAccess
      BRLanguage
      BRHealthcareProcess
      BROther
      BRResponseNote
      TGBetrayal
      TGBoundaries
      TGDisorder
      TGPain
      TGRejection
      TGStress
      TGMemories
      TGUnjustTreatment
      TGUnpleasantConversations
      TGUnsafeEnvironments
      TGOther
      WSFlashbacks
      WSIncreasedAppetite
      WSDecreasedAppetite
      WSIntenseEmotions
      WSDisconnecting
      WSTime
      WSNegativeSelfTalk
      WSNeglectingSelfCare
      WSNightmares
      WSRecklessBehavior
      WSOther
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCreatePlan = /* GraphQL */ `
  subscription OnDeleteCreatePlan(
    $filter: ModelSubscriptionCreatePlanFilterInput
    $userId: String
    $organizationId: String
  ) {
    onDeleteCreatePlan(
      filter: $filter
      userId: $userId
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      PSProblemSolving
      PSSelfEsteem
      PSChoiceAutonomy
      PSSelfCare
      PSSelfAwareness
      PSCreativity
      CSForgiveness
      CSKindness
      CSGratitude
      CSPatience
      CSCourage
      CMSCopingChoice
      CMSResilience
      CMSSelfRegulation
      CMSOptimism
      COMSupportSystem
      COMSocialIntelligence
      COMCommunication
      COMFaithCommunity
      COMAccomplishments
      BRStableHousing
      BRQualityHealthcare
      BRProfessionalAccess
      BRInsuranceCoverage
      BRFinancialConstraints
      BREducationAttainment
      BRSocialStigma
      BRUnsupportiveCommunity
      BRNonexistentCommunity
      BRCommunityResources
      BRProfessionalTrust
      BRHealthcareSystemTrust
      BRCognitiveImpairments
      BRDependentCare
      BRTransportation
      BRTechnologyAccess
      BRLanguage
      BRHealthcareProcess
      BROther
      BRResponseNote
      TGBetrayal
      TGBoundaries
      TGDisorder
      TGPain
      TGRejection
      TGStress
      TGMemories
      TGUnjustTreatment
      TGUnpleasantConversations
      TGUnsafeEnvironments
      TGOther
      WSFlashbacks
      WSIncreasedAppetite
      WSDecreasedAppetite
      WSIntenseEmotions
      WSDisconnecting
      WSTime
      WSNegativeSelfTalk
      WSNeglectingSelfCare
      WSNightmares
      WSRecklessBehavior
      WSOther
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateGeneralInformation = /* GraphQL */ `
  subscription OnCreateGeneralInformation(
    $filter: ModelSubscriptionGeneralInformationFilterInput
    $owner: String
    $organizationId: String
  ) {
    onCreateGeneralInformation(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      FirstName
      LastName
      Email
      ProfessionalRole
      BusinessName
      BusinessEIN
      BusinessCountry
      BusinessAddress
      BusinessCity
      BusinessState
      BusinessZipCode
      BusinessPhoneNumber
      BusinessWebsite
      OrganizationAdministrator
      OrganizationEmployee
      Department
      Service
      ProgramsUnit
      TrackPlan {
        nextToken
        __typename
      }
      AssessmentAnswers {
        nextToken
        __typename
      }
      ProfileType
      Login {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateGeneralInformation = /* GraphQL */ `
  subscription OnUpdateGeneralInformation(
    $filter: ModelSubscriptionGeneralInformationFilterInput
    $owner: String
    $organizationId: String
  ) {
    onUpdateGeneralInformation(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      FirstName
      LastName
      Email
      ProfessionalRole
      BusinessName
      BusinessEIN
      BusinessCountry
      BusinessAddress
      BusinessCity
      BusinessState
      BusinessZipCode
      BusinessPhoneNumber
      BusinessWebsite
      OrganizationAdministrator
      OrganizationEmployee
      Department
      Service
      ProgramsUnit
      TrackPlan {
        nextToken
        __typename
      }
      AssessmentAnswers {
        nextToken
        __typename
      }
      ProfileType
      Login {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteGeneralInformation = /* GraphQL */ `
  subscription OnDeleteGeneralInformation(
    $filter: ModelSubscriptionGeneralInformationFilterInput
    $owner: String
    $organizationId: String
  ) {
    onDeleteGeneralInformation(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      FirstName
      LastName
      Email
      ProfessionalRole
      BusinessName
      BusinessEIN
      BusinessCountry
      BusinessAddress
      BusinessCity
      BusinessState
      BusinessZipCode
      BusinessPhoneNumber
      BusinessWebsite
      OrganizationAdministrator
      OrganizationEmployee
      Department
      Service
      ProgramsUnit
      TrackPlan {
        nextToken
        __typename
      }
      AssessmentAnswers {
        nextToken
        __typename
      }
      ProfileType
      Login {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateAssessmentAnswers = /* GraphQL */ `
  subscription OnCreateAssessmentAnswers(
    $filter: ModelSubscriptionAssessmentAnswersFilterInput
    $owner: String
    $organizationId: String
  ) {
    onCreateAssessmentAnswers(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      CompletedDate
      CompletedTime
      TRHurtfulNames
      TRNoNurturing
      TRHit
      TRNeedsNotMet
      TRForcedSex
      TRResponsible
      TRViolence
      TRSubstanceAbuse
      TRMentalIllness
      TRParentDivorce
      TRParentIncarcerated
      TRHomelessness
      TRBodyFunction
      TRNaturalDisaster
      TRDirectTerrorism
      TRIndirectTerrorism
      TRLovedOne
      TRBelief
      TRResponseProfessional
      TRResponseFamilyFriend
      TRResponseGod
      TRResponseNoOne
      TRNoTrauma
      CMAlcohol
      CMDrugs
      CMOvereating
      CMSmoking
      CMGaming
      CMShopping
      CMGambling
      CMSex
      CMPorn
      CMBlaming
      CMHurting
      CMDisengage
      CMArt
      CMMusic
      CMPoetry
      CMReading
      CMGroups
      CMCounseling
      CMVenting
      CMWriting
      CMSensory
      CMDancing
      CMExercising
      CMWalking
      CMChange
      CMAnalyze
      CMDaydream
      CMPositive
      MHDxPTSD
      MHDxDepression
      MHDxSUD
      MHDxOtherMental
      MHSleeplessness
      MHAlcoholUse
      MHAnxiety
      MHDepression
      MHDrugUse
      MHGrief
      MHGuilt
      MHIrritability
      MHStress
      MHRegret
      MHSuicidalThoughts
      MHLoneliness
      MHWorry
      PHDxInfertility
      PHDxCurableSTD
      PHDxIncurableSTD
      PHDxCancer
      PHDxDiabetes
      PHDxHighBlood
      PHDxHeartDisease
      PHDxIrritableBowel
      PHDxVitA
      PHDxVitB
      PHDxVitC
      PHDxVitD
      PHDxVitE
      PHDxVitK
      PHDxAutoimmune
      PHDxOtherPhysical
      PHVegeFruits
      PHBeanLentils
      PHGrainBreads
      PHDairy
      PHMeat
      PHFishSeafood
      PHSweets
      PHWater
      PHPhysicalActivity
      SHSpiritualDefine
      SHSpiritualIntegrate
      SHPrayer
      SHSpiritualActivity
      SHReadText
      SHAlignText
      SHCommunity
      MHHope
      MHPeace
      SoHLearning
      MHJoy
      SoHStable
      SoHSafety
      SoHKindness
      SoHForgiveness
      SoHPatience
      SoHRelationships
      SoHContribution
      SoHBoundaries
      SoHEUnpleasant
      SoHEPleasant
      SoHEControl
      SDoHAgeRange
      SDoHRace
      SDoHGeographicRegion
      SDoHEthnicity
      SDoHState
      SDoHZipCode
      SDoHMaritalStatus
      SDoHMilitaryStatus
      SDoHGender
      SDoHEducation
      SDoHJobStatus
      SDoHIncome
      SDoHHousingStatus
      SDoHHomeAsChild
      TrackPlan {
        nextToken
        __typename
      }
      GeneralInformation {
        nextToken
        __typename
      }
      SDoHReligion
      SDoHDenomination
      isActive
      SHSkip
      ProAssessmentFinalizedReview1
      ProAssessmentFinalizedReviewDate1
      ProAssessmentFinalizedName1
      ProAssessmentFinalizedRole1
      ProAssessmentFinalizedReview2
      ProAssessmentFinalizedReviewDate2
      ProAssessmentFinalizedName2
      ProAssessmentFinalizedRole2
      ProAssessmentFinalizedReview3
      ProAssessmentFinalizedReviewDate3
      ProAssessmentFinalizedName3
      ProAssessmentFinalizedRole3
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateAssessmentAnswers = /* GraphQL */ `
  subscription OnUpdateAssessmentAnswers(
    $filter: ModelSubscriptionAssessmentAnswersFilterInput
    $owner: String
    $organizationId: String
  ) {
    onUpdateAssessmentAnswers(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      CompletedDate
      CompletedTime
      TRHurtfulNames
      TRNoNurturing
      TRHit
      TRNeedsNotMet
      TRForcedSex
      TRResponsible
      TRViolence
      TRSubstanceAbuse
      TRMentalIllness
      TRParentDivorce
      TRParentIncarcerated
      TRHomelessness
      TRBodyFunction
      TRNaturalDisaster
      TRDirectTerrorism
      TRIndirectTerrorism
      TRLovedOne
      TRBelief
      TRResponseProfessional
      TRResponseFamilyFriend
      TRResponseGod
      TRResponseNoOne
      TRNoTrauma
      CMAlcohol
      CMDrugs
      CMOvereating
      CMSmoking
      CMGaming
      CMShopping
      CMGambling
      CMSex
      CMPorn
      CMBlaming
      CMHurting
      CMDisengage
      CMArt
      CMMusic
      CMPoetry
      CMReading
      CMGroups
      CMCounseling
      CMVenting
      CMWriting
      CMSensory
      CMDancing
      CMExercising
      CMWalking
      CMChange
      CMAnalyze
      CMDaydream
      CMPositive
      MHDxPTSD
      MHDxDepression
      MHDxSUD
      MHDxOtherMental
      MHSleeplessness
      MHAlcoholUse
      MHAnxiety
      MHDepression
      MHDrugUse
      MHGrief
      MHGuilt
      MHIrritability
      MHStress
      MHRegret
      MHSuicidalThoughts
      MHLoneliness
      MHWorry
      PHDxInfertility
      PHDxCurableSTD
      PHDxIncurableSTD
      PHDxCancer
      PHDxDiabetes
      PHDxHighBlood
      PHDxHeartDisease
      PHDxIrritableBowel
      PHDxVitA
      PHDxVitB
      PHDxVitC
      PHDxVitD
      PHDxVitE
      PHDxVitK
      PHDxAutoimmune
      PHDxOtherPhysical
      PHVegeFruits
      PHBeanLentils
      PHGrainBreads
      PHDairy
      PHMeat
      PHFishSeafood
      PHSweets
      PHWater
      PHPhysicalActivity
      SHSpiritualDefine
      SHSpiritualIntegrate
      SHPrayer
      SHSpiritualActivity
      SHReadText
      SHAlignText
      SHCommunity
      MHHope
      MHPeace
      SoHLearning
      MHJoy
      SoHStable
      SoHSafety
      SoHKindness
      SoHForgiveness
      SoHPatience
      SoHRelationships
      SoHContribution
      SoHBoundaries
      SoHEUnpleasant
      SoHEPleasant
      SoHEControl
      SDoHAgeRange
      SDoHRace
      SDoHGeographicRegion
      SDoHEthnicity
      SDoHState
      SDoHZipCode
      SDoHMaritalStatus
      SDoHMilitaryStatus
      SDoHGender
      SDoHEducation
      SDoHJobStatus
      SDoHIncome
      SDoHHousingStatus
      SDoHHomeAsChild
      TrackPlan {
        nextToken
        __typename
      }
      GeneralInformation {
        nextToken
        __typename
      }
      SDoHReligion
      SDoHDenomination
      isActive
      SHSkip
      ProAssessmentFinalizedReview1
      ProAssessmentFinalizedReviewDate1
      ProAssessmentFinalizedName1
      ProAssessmentFinalizedRole1
      ProAssessmentFinalizedReview2
      ProAssessmentFinalizedReviewDate2
      ProAssessmentFinalizedName2
      ProAssessmentFinalizedRole2
      ProAssessmentFinalizedReview3
      ProAssessmentFinalizedReviewDate3
      ProAssessmentFinalizedName3
      ProAssessmentFinalizedRole3
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteAssessmentAnswers = /* GraphQL */ `
  subscription OnDeleteAssessmentAnswers(
    $filter: ModelSubscriptionAssessmentAnswersFilterInput
    $owner: String
    $organizationId: String
  ) {
    onDeleteAssessmentAnswers(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      CompletedDate
      CompletedTime
      TRHurtfulNames
      TRNoNurturing
      TRHit
      TRNeedsNotMet
      TRForcedSex
      TRResponsible
      TRViolence
      TRSubstanceAbuse
      TRMentalIllness
      TRParentDivorce
      TRParentIncarcerated
      TRHomelessness
      TRBodyFunction
      TRNaturalDisaster
      TRDirectTerrorism
      TRIndirectTerrorism
      TRLovedOne
      TRBelief
      TRResponseProfessional
      TRResponseFamilyFriend
      TRResponseGod
      TRResponseNoOne
      TRNoTrauma
      CMAlcohol
      CMDrugs
      CMOvereating
      CMSmoking
      CMGaming
      CMShopping
      CMGambling
      CMSex
      CMPorn
      CMBlaming
      CMHurting
      CMDisengage
      CMArt
      CMMusic
      CMPoetry
      CMReading
      CMGroups
      CMCounseling
      CMVenting
      CMWriting
      CMSensory
      CMDancing
      CMExercising
      CMWalking
      CMChange
      CMAnalyze
      CMDaydream
      CMPositive
      MHDxPTSD
      MHDxDepression
      MHDxSUD
      MHDxOtherMental
      MHSleeplessness
      MHAlcoholUse
      MHAnxiety
      MHDepression
      MHDrugUse
      MHGrief
      MHGuilt
      MHIrritability
      MHStress
      MHRegret
      MHSuicidalThoughts
      MHLoneliness
      MHWorry
      PHDxInfertility
      PHDxCurableSTD
      PHDxIncurableSTD
      PHDxCancer
      PHDxDiabetes
      PHDxHighBlood
      PHDxHeartDisease
      PHDxIrritableBowel
      PHDxVitA
      PHDxVitB
      PHDxVitC
      PHDxVitD
      PHDxVitE
      PHDxVitK
      PHDxAutoimmune
      PHDxOtherPhysical
      PHVegeFruits
      PHBeanLentils
      PHGrainBreads
      PHDairy
      PHMeat
      PHFishSeafood
      PHSweets
      PHWater
      PHPhysicalActivity
      SHSpiritualDefine
      SHSpiritualIntegrate
      SHPrayer
      SHSpiritualActivity
      SHReadText
      SHAlignText
      SHCommunity
      MHHope
      MHPeace
      SoHLearning
      MHJoy
      SoHStable
      SoHSafety
      SoHKindness
      SoHForgiveness
      SoHPatience
      SoHRelationships
      SoHContribution
      SoHBoundaries
      SoHEUnpleasant
      SoHEPleasant
      SoHEControl
      SDoHAgeRange
      SDoHRace
      SDoHGeographicRegion
      SDoHEthnicity
      SDoHState
      SDoHZipCode
      SDoHMaritalStatus
      SDoHMilitaryStatus
      SDoHGender
      SDoHEducation
      SDoHJobStatus
      SDoHIncome
      SDoHHousingStatus
      SDoHHomeAsChild
      TrackPlan {
        nextToken
        __typename
      }
      GeneralInformation {
        nextToken
        __typename
      }
      SDoHReligion
      SDoHDenomination
      isActive
      SHSkip
      ProAssessmentFinalizedReview1
      ProAssessmentFinalizedReviewDate1
      ProAssessmentFinalizedName1
      ProAssessmentFinalizedRole1
      ProAssessmentFinalizedReview2
      ProAssessmentFinalizedReviewDate2
      ProAssessmentFinalizedName2
      ProAssessmentFinalizedRole2
      ProAssessmentFinalizedReview3
      ProAssessmentFinalizedReviewDate3
      ProAssessmentFinalizedName3
      ProAssessmentFinalizedRole3
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateAssessmentScores = /* GraphQL */ `
  subscription OnCreateAssessmentScores(
    $filter: ModelSubscriptionAssessmentScoresFilterInput
    $owner: String
    $organizationId: String
  ) {
    onCreateAssessmentScores(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      CompletedDate
      CompletedTime
      TRHurtfulNames
      TRNoNurturing
      TRHit
      TRNeedsNotMet
      TRForcedSex
      TRResponsible
      TRViolence
      TRSubstanceAbuse
      TRMentalIllness
      TRParentDivorce
      TRParentIncarcerated
      TRHomelessness
      TRBodyFunction
      TRNaturalDisaster
      TRDirectTerrorism
      TRIndirectTerrorism
      TRLovedOne
      TRBelief
      TRResponseProfessional
      TRResponseFamilyFriend
      TRResponseGod
      TRResponseNoOne
      TRNoTrauma
      CMAlcohol
      CMDrugs
      CMOvereating
      CMSmoking
      CMGaming
      CMShopping
      CMGambling
      CMSex
      CMPorn
      CMBlaming
      CMHurting
      CMDisengage
      CMArt
      CMMusic
      CMPoetry
      CMReading
      CMGroups
      CMCounseling
      CMVenting
      CMWriting
      CMSensory
      CMDancing
      CMExercising
      CMWalking
      CMChange
      CMAnalyze
      CMDaydream
      CMPositive
      MHDxPTSD
      MHDxDepression
      MHDxSUD
      MHDxOtherMental
      MHSleeplessness
      MHAlcoholUse
      MHAnxiety
      MHDepression
      MHDrugUse
      MHGrief
      MHGuilt
      MHIrritability
      MHStress
      MHRegret
      MHSuicidalThoughts
      MHLoneliness
      MHWorry
      PHDxInfertility
      PHDxCurableSTD
      PHDxIncurableSTD
      PHDxCancer
      PHDxDiabetes
      PHDxHighBlood
      PHDxHeartDisease
      PHDxIrritableBowel
      PHDxVitA
      PHDxVitB
      PHDxVitC
      PHDxVitD
      PHDxVitE
      PHDxVitK
      PHDxAutoimmune
      PHDxOtherPhysical
      PHVegeFruits
      PHBeanLentils
      PHGrainBreads
      PHDairy
      PHMeat
      PHFishSeafood
      PHSweets
      PHWater
      PHPhysicalActivity
      SHSpiritualDefine
      SHSpiritualIntegrate
      SHPrayer
      SHSpiritualActivity
      SHReadText
      SHAlignText
      SHCommunity
      MHHope
      MHPeace
      SoHLearning
      MHJoy
      SoHStable
      SoHSafety
      SoHKindness
      SoHForgiveness
      SoHPatience
      SoHRelationships
      SoHContribution
      SoHBoundaries
      SoHEUnpleasant
      SoHEPleasant
      SoHEControl
      SDoHAgeRange
      SDoHRace
      SDoHGeographicRegion
      SDoHEthnicity
      SDoHState
      SDoHZipCode
      SDoHMaritalStatus
      SDoHMilitaryStatus
      SDoHGender
      SDoHEducation
      SDoHJobStatus
      SDoHIncome
      SDoHHousingStatus
      SDoHHomeAsChild
      SDoHReligion
      SDoHDenomination
      TRScore
      CMScore
      MHScore
      PHScore
      SHScore
      SoHScore
      isActive
      SHSkip
      ProAssessmentFinalizedReview1
      ProAssessmentFinalizedReviewDate1
      ProAssessmentFinalizedName1
      ProAssessmentFinalizedRole1
      ProAssessmentFinalizedReview2
      ProAssessmentFinalizedReviewDate2
      ProAssessmentFinalizedName2
      ProAssessmentFinalizedRole2
      ProAssessmentFinalizedReview3
      ProAssessmentFinalizedReviewDate3
      ProAssessmentFinalizedName3
      ProAssessmentFinalizedRole3
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateAssessmentScores = /* GraphQL */ `
  subscription OnUpdateAssessmentScores(
    $filter: ModelSubscriptionAssessmentScoresFilterInput
    $owner: String
    $organizationId: String
  ) {
    onUpdateAssessmentScores(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      CompletedDate
      CompletedTime
      TRHurtfulNames
      TRNoNurturing
      TRHit
      TRNeedsNotMet
      TRForcedSex
      TRResponsible
      TRViolence
      TRSubstanceAbuse
      TRMentalIllness
      TRParentDivorce
      TRParentIncarcerated
      TRHomelessness
      TRBodyFunction
      TRNaturalDisaster
      TRDirectTerrorism
      TRIndirectTerrorism
      TRLovedOne
      TRBelief
      TRResponseProfessional
      TRResponseFamilyFriend
      TRResponseGod
      TRResponseNoOne
      TRNoTrauma
      CMAlcohol
      CMDrugs
      CMOvereating
      CMSmoking
      CMGaming
      CMShopping
      CMGambling
      CMSex
      CMPorn
      CMBlaming
      CMHurting
      CMDisengage
      CMArt
      CMMusic
      CMPoetry
      CMReading
      CMGroups
      CMCounseling
      CMVenting
      CMWriting
      CMSensory
      CMDancing
      CMExercising
      CMWalking
      CMChange
      CMAnalyze
      CMDaydream
      CMPositive
      MHDxPTSD
      MHDxDepression
      MHDxSUD
      MHDxOtherMental
      MHSleeplessness
      MHAlcoholUse
      MHAnxiety
      MHDepression
      MHDrugUse
      MHGrief
      MHGuilt
      MHIrritability
      MHStress
      MHRegret
      MHSuicidalThoughts
      MHLoneliness
      MHWorry
      PHDxInfertility
      PHDxCurableSTD
      PHDxIncurableSTD
      PHDxCancer
      PHDxDiabetes
      PHDxHighBlood
      PHDxHeartDisease
      PHDxIrritableBowel
      PHDxVitA
      PHDxVitB
      PHDxVitC
      PHDxVitD
      PHDxVitE
      PHDxVitK
      PHDxAutoimmune
      PHDxOtherPhysical
      PHVegeFruits
      PHBeanLentils
      PHGrainBreads
      PHDairy
      PHMeat
      PHFishSeafood
      PHSweets
      PHWater
      PHPhysicalActivity
      SHSpiritualDefine
      SHSpiritualIntegrate
      SHPrayer
      SHSpiritualActivity
      SHReadText
      SHAlignText
      SHCommunity
      MHHope
      MHPeace
      SoHLearning
      MHJoy
      SoHStable
      SoHSafety
      SoHKindness
      SoHForgiveness
      SoHPatience
      SoHRelationships
      SoHContribution
      SoHBoundaries
      SoHEUnpleasant
      SoHEPleasant
      SoHEControl
      SDoHAgeRange
      SDoHRace
      SDoHGeographicRegion
      SDoHEthnicity
      SDoHState
      SDoHZipCode
      SDoHMaritalStatus
      SDoHMilitaryStatus
      SDoHGender
      SDoHEducation
      SDoHJobStatus
      SDoHIncome
      SDoHHousingStatus
      SDoHHomeAsChild
      SDoHReligion
      SDoHDenomination
      TRScore
      CMScore
      MHScore
      PHScore
      SHScore
      SoHScore
      isActive
      SHSkip
      ProAssessmentFinalizedReview1
      ProAssessmentFinalizedReviewDate1
      ProAssessmentFinalizedName1
      ProAssessmentFinalizedRole1
      ProAssessmentFinalizedReview2
      ProAssessmentFinalizedReviewDate2
      ProAssessmentFinalizedName2
      ProAssessmentFinalizedRole2
      ProAssessmentFinalizedReview3
      ProAssessmentFinalizedReviewDate3
      ProAssessmentFinalizedName3
      ProAssessmentFinalizedRole3
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteAssessmentScores = /* GraphQL */ `
  subscription OnDeleteAssessmentScores(
    $filter: ModelSubscriptionAssessmentScoresFilterInput
    $owner: String
    $organizationId: String
  ) {
    onDeleteAssessmentScores(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      CompletedDate
      CompletedTime
      TRHurtfulNames
      TRNoNurturing
      TRHit
      TRNeedsNotMet
      TRForcedSex
      TRResponsible
      TRViolence
      TRSubstanceAbuse
      TRMentalIllness
      TRParentDivorce
      TRParentIncarcerated
      TRHomelessness
      TRBodyFunction
      TRNaturalDisaster
      TRDirectTerrorism
      TRIndirectTerrorism
      TRLovedOne
      TRBelief
      TRResponseProfessional
      TRResponseFamilyFriend
      TRResponseGod
      TRResponseNoOne
      TRNoTrauma
      CMAlcohol
      CMDrugs
      CMOvereating
      CMSmoking
      CMGaming
      CMShopping
      CMGambling
      CMSex
      CMPorn
      CMBlaming
      CMHurting
      CMDisengage
      CMArt
      CMMusic
      CMPoetry
      CMReading
      CMGroups
      CMCounseling
      CMVenting
      CMWriting
      CMSensory
      CMDancing
      CMExercising
      CMWalking
      CMChange
      CMAnalyze
      CMDaydream
      CMPositive
      MHDxPTSD
      MHDxDepression
      MHDxSUD
      MHDxOtherMental
      MHSleeplessness
      MHAlcoholUse
      MHAnxiety
      MHDepression
      MHDrugUse
      MHGrief
      MHGuilt
      MHIrritability
      MHStress
      MHRegret
      MHSuicidalThoughts
      MHLoneliness
      MHWorry
      PHDxInfertility
      PHDxCurableSTD
      PHDxIncurableSTD
      PHDxCancer
      PHDxDiabetes
      PHDxHighBlood
      PHDxHeartDisease
      PHDxIrritableBowel
      PHDxVitA
      PHDxVitB
      PHDxVitC
      PHDxVitD
      PHDxVitE
      PHDxVitK
      PHDxAutoimmune
      PHDxOtherPhysical
      PHVegeFruits
      PHBeanLentils
      PHGrainBreads
      PHDairy
      PHMeat
      PHFishSeafood
      PHSweets
      PHWater
      PHPhysicalActivity
      SHSpiritualDefine
      SHSpiritualIntegrate
      SHPrayer
      SHSpiritualActivity
      SHReadText
      SHAlignText
      SHCommunity
      MHHope
      MHPeace
      SoHLearning
      MHJoy
      SoHStable
      SoHSafety
      SoHKindness
      SoHForgiveness
      SoHPatience
      SoHRelationships
      SoHContribution
      SoHBoundaries
      SoHEUnpleasant
      SoHEPleasant
      SoHEControl
      SDoHAgeRange
      SDoHRace
      SDoHGeographicRegion
      SDoHEthnicity
      SDoHState
      SDoHZipCode
      SDoHMaritalStatus
      SDoHMilitaryStatus
      SDoHGender
      SDoHEducation
      SDoHJobStatus
      SDoHIncome
      SDoHHousingStatus
      SDoHHomeAsChild
      SDoHReligion
      SDoHDenomination
      TRScore
      CMScore
      MHScore
      PHScore
      SHScore
      SoHScore
      isActive
      SHSkip
      ProAssessmentFinalizedReview1
      ProAssessmentFinalizedReviewDate1
      ProAssessmentFinalizedName1
      ProAssessmentFinalizedRole1
      ProAssessmentFinalizedReview2
      ProAssessmentFinalizedReviewDate2
      ProAssessmentFinalizedName2
      ProAssessmentFinalizedRole2
      ProAssessmentFinalizedReview3
      ProAssessmentFinalizedReviewDate3
      ProAssessmentFinalizedName3
      ProAssessmentFinalizedRole3
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateTrackPlan = /* GraphQL */ `
  subscription OnCreateTrackPlan(
    $filter: ModelSubscriptionTrackPlanFilterInput
    $owner: String
    $organizationId: String
  ) {
    onCreateTrackPlan(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      CompletedDate
      CompletedTime
      ActionDomain
      ActionQuestion
      Action
      Frequency
      ActionNote
      Update1Points
      Update1Note
      Update1Date
      Update2Points
      Update2Note
      Update2Date
      Update3Points
      Update3Note
      Update3Date
      Update4Points
      Update4Note
      Update4Date
      Update5Points
      Update5Note
      Update5Date
      Update6Points
      Update6Note
      Update6Date
      Update7Points
      Update7Note
      Update7Date
      Update8Points
      Update8Note
      Update8Date
      Percentage
      Discontinued
      DiscontinuedDate
      Successful
      SuccessfulDate
      AssessmentAnswers {
        nextToken
        __typename
      }
      GeneralInformation {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateTrackPlan = /* GraphQL */ `
  subscription OnUpdateTrackPlan(
    $filter: ModelSubscriptionTrackPlanFilterInput
    $owner: String
    $organizationId: String
  ) {
    onUpdateTrackPlan(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      CompletedDate
      CompletedTime
      ActionDomain
      ActionQuestion
      Action
      Frequency
      ActionNote
      Update1Points
      Update1Note
      Update1Date
      Update2Points
      Update2Note
      Update2Date
      Update3Points
      Update3Note
      Update3Date
      Update4Points
      Update4Note
      Update4Date
      Update5Points
      Update5Note
      Update5Date
      Update6Points
      Update6Note
      Update6Date
      Update7Points
      Update7Note
      Update7Date
      Update8Points
      Update8Note
      Update8Date
      Percentage
      Discontinued
      DiscontinuedDate
      Successful
      SuccessfulDate
      AssessmentAnswers {
        nextToken
        __typename
      }
      GeneralInformation {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteTrackPlan = /* GraphQL */ `
  subscription OnDeleteTrackPlan(
    $filter: ModelSubscriptionTrackPlanFilterInput
    $owner: String
    $organizationId: String
  ) {
    onDeleteTrackPlan(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      CompletedDate
      CompletedTime
      ActionDomain
      ActionQuestion
      Action
      Frequency
      ActionNote
      Update1Points
      Update1Note
      Update1Date
      Update2Points
      Update2Note
      Update2Date
      Update3Points
      Update3Note
      Update3Date
      Update4Points
      Update4Note
      Update4Date
      Update5Points
      Update5Note
      Update5Date
      Update6Points
      Update6Note
      Update6Date
      Update7Points
      Update7Note
      Update7Date
      Update8Points
      Update8Note
      Update8Date
      Percentage
      Discontinued
      DiscontinuedDate
      Successful
      SuccessfulDate
      AssessmentAnswers {
        nextToken
        __typename
      }
      GeneralInformation {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateConnectionRequest = /* GraphQL */ `
  subscription OnCreateConnectionRequest(
    $filter: ModelSubscriptionConnectionRequestFilterInput
    $requesterId: String
    $targetEmail: String
    $targetUserId: String
  ) {
    onCreateConnectionRequest(
      filter: $filter
      requesterId: $requesterId
      targetEmail: $targetEmail
      targetUserId: $targetUserId
    ) {
      id
      requesterId
      requesterFirstName
      requesterLastName
      requesterEmail
      targetEmail
      targetUserId
      organizationId
      status
      direction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateConnectionRequest = /* GraphQL */ `
  subscription OnUpdateConnectionRequest(
    $filter: ModelSubscriptionConnectionRequestFilterInput
    $requesterId: String
    $targetEmail: String
    $targetUserId: String
  ) {
    onUpdateConnectionRequest(
      filter: $filter
      requesterId: $requesterId
      targetEmail: $targetEmail
      targetUserId: $targetUserId
    ) {
      id
      requesterId
      requesterFirstName
      requesterLastName
      requesterEmail
      targetEmail
      targetUserId
      organizationId
      status
      direction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteConnectionRequest = /* GraphQL */ `
  subscription OnDeleteConnectionRequest(
    $filter: ModelSubscriptionConnectionRequestFilterInput
    $requesterId: String
    $targetEmail: String
    $targetUserId: String
  ) {
    onDeleteConnectionRequest(
      filter: $filter
      requesterId: $requesterId
      targetEmail: $targetEmail
      targetUserId: $targetUserId
    ) {
      id
      requesterId
      requesterFirstName
      requesterLastName
      requesterEmail
      targetEmail
      targetUserId
      organizationId
      status
      direction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserLink = /* GraphQL */ `
  subscription OnCreateUserLink(
    $filter: ModelSubscriptionUserLinkFilterInput
    $professionalId: String
    $clientId: String
    $organizationId: String
  ) {
    onCreateUserLink(
      filter: $filter
      professionalId: $professionalId
      clientId: $clientId
      organizationId: $organizationId
    ) {
      id
      organizationId
      professionalId
      professionalEmail
      professionalFirstName
      professionalLastName
      professionalRole
      clientId
      clientEmail
      clientFirstName
      clientLastName
      linkedAt
      unlinkedAt
      clientViewable
      subscriptionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserLink = /* GraphQL */ `
  subscription OnUpdateUserLink(
    $filter: ModelSubscriptionUserLinkFilterInput
    $professionalId: String
    $clientId: String
    $organizationId: String
  ) {
    onUpdateUserLink(
      filter: $filter
      professionalId: $professionalId
      clientId: $clientId
      organizationId: $organizationId
    ) {
      id
      organizationId
      professionalId
      professionalEmail
      professionalFirstName
      professionalLastName
      professionalRole
      clientId
      clientEmail
      clientFirstName
      clientLastName
      linkedAt
      unlinkedAt
      clientViewable
      subscriptionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserLink = /* GraphQL */ `
  subscription OnDeleteUserLink(
    $filter: ModelSubscriptionUserLinkFilterInput
    $professionalId: String
    $clientId: String
    $organizationId: String
  ) {
    onDeleteUserLink(
      filter: $filter
      professionalId: $professionalId
      clientId: $clientId
      organizationId: $organizationId
    ) {
      id
      organizationId
      professionalId
      professionalEmail
      professionalFirstName
      professionalLastName
      professionalRole
      clientId
      clientEmail
      clientFirstName
      clientLastName
      linkedAt
      unlinkedAt
      clientViewable
      subscriptionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateOrganizationInformation = /* GraphQL */ `
  subscription OnCreateOrganizationInformation(
    $filter: ModelSubscriptionOrganizationInformationFilterInput
    $userId: String
    $organizationId: String
  ) {
    onCreateOrganizationInformation(
      filter: $filter
      userId: $userId
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      BusinessName
      BusinessEIN
      BusinessCountry
      BusinessAddress
      BusinessCity
      BusinessState
      BusinessZipCode
      BusinessPhoneNumber
      BusinessWebsite
      Departments
      ProgramsUnits
      Services
      clientsServed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOrganizationInformation = /* GraphQL */ `
  subscription OnUpdateOrganizationInformation(
    $filter: ModelSubscriptionOrganizationInformationFilterInput
    $userId: String
    $organizationId: String
  ) {
    onUpdateOrganizationInformation(
      filter: $filter
      userId: $userId
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      BusinessName
      BusinessEIN
      BusinessCountry
      BusinessAddress
      BusinessCity
      BusinessState
      BusinessZipCode
      BusinessPhoneNumber
      BusinessWebsite
      Departments
      ProgramsUnits
      Services
      clientsServed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOrganizationInformation = /* GraphQL */ `
  subscription OnDeleteOrganizationInformation(
    $filter: ModelSubscriptionOrganizationInformationFilterInput
    $userId: String
    $organizationId: String
  ) {
    onDeleteOrganizationInformation(
      filter: $filter
      userId: $userId
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      BusinessName
      BusinessEIN
      BusinessCountry
      BusinessAddress
      BusinessCity
      BusinessState
      BusinessZipCode
      BusinessPhoneNumber
      BusinessWebsite
      Departments
      ProgramsUnits
      Services
      clientsServed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateOrganizationCPs = /* GraphQL */ `
  subscription OnCreateOrganizationCPs(
    $filter: ModelSubscriptionOrganizationCPsFilterInput
    $owner: String
    $OrganizationCPEmail: String
    $OrganizationId: String
  ) {
    onCreateOrganizationCPs(
      filter: $filter
      owner: $owner
      OrganizationCPEmail: $OrganizationCPEmail
      OrganizationId: $OrganizationId
    ) {
      id
      OrganizationId
      OrganizationCPFirstName
      OrganizationCPLastName
      OrganizationCPEmail
      OrganizationCPRole
      primaryDepartment
      primaryProgramsUnit
      primaryService
      OrganizationAdministrator
      PrimaryOrganizationAdministrator
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOrganizationCPs = /* GraphQL */ `
  subscription OnUpdateOrganizationCPs(
    $filter: ModelSubscriptionOrganizationCPsFilterInput
    $owner: String
    $OrganizationCPEmail: String
    $OrganizationId: String
  ) {
    onUpdateOrganizationCPs(
      filter: $filter
      owner: $owner
      OrganizationCPEmail: $OrganizationCPEmail
      OrganizationId: $OrganizationId
    ) {
      id
      OrganizationId
      OrganizationCPFirstName
      OrganizationCPLastName
      OrganizationCPEmail
      OrganizationCPRole
      primaryDepartment
      primaryProgramsUnit
      primaryService
      OrganizationAdministrator
      PrimaryOrganizationAdministrator
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOrganizationCPs = /* GraphQL */ `
  subscription OnDeleteOrganizationCPs(
    $filter: ModelSubscriptionOrganizationCPsFilterInput
    $owner: String
    $OrganizationCPEmail: String
    $OrganizationId: String
  ) {
    onDeleteOrganizationCPs(
      filter: $filter
      owner: $owner
      OrganizationCPEmail: $OrganizationCPEmail
      OrganizationId: $OrganizationId
    ) {
      id
      OrganizationId
      OrganizationCPFirstName
      OrganizationCPLastName
      OrganizationCPEmail
      OrganizationCPRole
      primaryDepartment
      primaryProgramsUnit
      primaryService
      OrganizationAdministrator
      PrimaryOrganizationAdministrator
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateNotifications = /* GraphQL */ `
  subscription OnCreateNotifications(
    $filter: ModelSubscriptionNotificationsFilterInput
    $SenderId: String
    $organizationId: String
    $TargetEmail: String
    $TargetUserId: String
  ) {
    onCreateNotifications(
      filter: $filter
      SenderId: $SenderId
      organizationId: $organizationId
      TargetEmail: $TargetEmail
      TargetUserId: $TargetUserId
    ) {
      id
      organizationId
      RecommendationResult
      RecommendationAction
      RecommendationActionFrequency
      RecommendationType
      RecommendationNote
      RecommendationDate
      SenderId
      SenderFirstName
      SenderLastName
      SenderEmail
      TargetEmail
      TargetUserId
      NotificationType
      StatusDate
      Status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateNotifications = /* GraphQL */ `
  subscription OnUpdateNotifications(
    $filter: ModelSubscriptionNotificationsFilterInput
    $SenderId: String
    $organizationId: String
    $TargetEmail: String
    $TargetUserId: String
  ) {
    onUpdateNotifications(
      filter: $filter
      SenderId: $SenderId
      organizationId: $organizationId
      TargetEmail: $TargetEmail
      TargetUserId: $TargetUserId
    ) {
      id
      organizationId
      RecommendationResult
      RecommendationAction
      RecommendationActionFrequency
      RecommendationType
      RecommendationNote
      RecommendationDate
      SenderId
      SenderFirstName
      SenderLastName
      SenderEmail
      TargetEmail
      TargetUserId
      NotificationType
      StatusDate
      Status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteNotifications = /* GraphQL */ `
  subscription OnDeleteNotifications(
    $filter: ModelSubscriptionNotificationsFilterInput
    $SenderId: String
    $organizationId: String
    $TargetEmail: String
    $TargetUserId: String
  ) {
    onDeleteNotifications(
      filter: $filter
      SenderId: $SenderId
      organizationId: $organizationId
      TargetEmail: $TargetEmail
      TargetUserId: $TargetUserId
    ) {
      id
      organizationId
      RecommendationResult
      RecommendationAction
      RecommendationActionFrequency
      RecommendationType
      RecommendationNote
      RecommendationDate
      SenderId
      SenderFirstName
      SenderLastName
      SenderEmail
      TargetEmail
      TargetUserId
      NotificationType
      StatusDate
      Status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserPayments = /* GraphQL */ `
  subscription OnCreateUserPayments(
    $filter: ModelSubscriptionUserPaymentsFilterInput
    $owner: String
    $organizationId: String
  ) {
    onCreateUserPayments(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      organizationName
      paymentType
      subscriptionId
      paymentStatus
      clientsProjected
      costPerClient
      couponCode
      couponPercent
      paidUntil
      paymentFor
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateUserPayments = /* GraphQL */ `
  subscription OnUpdateUserPayments(
    $filter: ModelSubscriptionUserPaymentsFilterInput
    $owner: String
    $organizationId: String
  ) {
    onUpdateUserPayments(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      organizationName
      paymentType
      subscriptionId
      paymentStatus
      clientsProjected
      costPerClient
      couponCode
      couponPercent
      paidUntil
      paymentFor
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteUserPayments = /* GraphQL */ `
  subscription OnDeleteUserPayments(
    $filter: ModelSubscriptionUserPaymentsFilterInput
    $owner: String
    $organizationId: String
  ) {
    onDeleteUserPayments(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      userId
      organizationId
      organizationName
      paymentType
      subscriptionId
      paymentStatus
      clientsProjected
      costPerClient
      couponCode
      couponPercent
      paidUntil
      paymentFor
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateCoupon = /* GraphQL */ `
  subscription OnCreateCoupon($filter: ModelSubscriptionCouponFilterInput) {
    onCreateCoupon(filter: $filter) {
      id
      type
      value
      isActive
      maxUses
      timesUsed
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCoupon = /* GraphQL */ `
  subscription OnUpdateCoupon($filter: ModelSubscriptionCouponFilterInput) {
    onUpdateCoupon(filter: $filter) {
      id
      type
      value
      isActive
      maxUses
      timesUsed
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCoupon = /* GraphQL */ `
  subscription OnDeleteCoupon($filter: ModelSubscriptionCouponFilterInput) {
    onDeleteCoupon(filter: $filter) {
      id
      type
      value
      isActive
      maxUses
      timesUsed
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateProfessionalReviews = /* GraphQL */ `
  subscription OnCreateProfessionalReviews(
    $filter: ModelSubscriptionProfessionalReviewsFilterInput
    $owner: String
    $organizationId: String
  ) {
    onCreateProfessionalReviews(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      ReviewedId
      organizationId
      ReviewType
      ProfessionalName
      ProfessionalRole
      ReviewDate
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateProfessionalReviews = /* GraphQL */ `
  subscription OnUpdateProfessionalReviews(
    $filter: ModelSubscriptionProfessionalReviewsFilterInput
    $owner: String
    $organizationId: String
  ) {
    onUpdateProfessionalReviews(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      ReviewedId
      organizationId
      ReviewType
      ProfessionalName
      ProfessionalRole
      ReviewDate
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteProfessionalReviews = /* GraphQL */ `
  subscription OnDeleteProfessionalReviews(
    $filter: ModelSubscriptionProfessionalReviewsFilterInput
    $owner: String
    $organizationId: String
  ) {
    onDeleteProfessionalReviews(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      ReviewedId
      organizationId
      ReviewType
      ProfessionalName
      ProfessionalRole
      ReviewDate
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateLabResults = /* GraphQL */ `
  subscription OnCreateLabResults(
    $filter: ModelSubscriptionLabResultsFilterInput
    $owner: String
  ) {
    onCreateLabResults(filter: $filter, owner: $owner) {
      id
      userId
      CompletedDate
      CompletedTime
      isActive
      LabsTG
      LabsTC
      LabsHDL
      LabsLDL
      LabsNa
      LabsK
      LabsP
      LabsCl
      LabsZn
      LabsCa
      LabsMg
      LabsFe
      LabsFerritin
      LabsVitA
      LabsVitB1
      LabsVitB2
      LabsVitB3
      LabsVitB5
      LabsVitB6
      LabsVitB7
      LabsVitB9
      LabsVitB12
      LabsVitC
      LabsVitD
      LabsVitE
      LabsVitK
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateLabResults = /* GraphQL */ `
  subscription OnUpdateLabResults(
    $filter: ModelSubscriptionLabResultsFilterInput
    $owner: String
  ) {
    onUpdateLabResults(filter: $filter, owner: $owner) {
      id
      userId
      CompletedDate
      CompletedTime
      isActive
      LabsTG
      LabsTC
      LabsHDL
      LabsLDL
      LabsNa
      LabsK
      LabsP
      LabsCl
      LabsZn
      LabsCa
      LabsMg
      LabsFe
      LabsFerritin
      LabsVitA
      LabsVitB1
      LabsVitB2
      LabsVitB3
      LabsVitB5
      LabsVitB6
      LabsVitB7
      LabsVitB9
      LabsVitB12
      LabsVitC
      LabsVitD
      LabsVitE
      LabsVitK
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteLabResults = /* GraphQL */ `
  subscription OnDeleteLabResults(
    $filter: ModelSubscriptionLabResultsFilterInput
    $owner: String
  ) {
    onDeleteLabResults(filter: $filter, owner: $owner) {
      id
      userId
      CompletedDate
      CompletedTime
      isActive
      LabsTG
      LabsTC
      LabsHDL
      LabsLDL
      LabsNa
      LabsK
      LabsP
      LabsCl
      LabsZn
      LabsCa
      LabsMg
      LabsFe
      LabsFerritin
      LabsVitA
      LabsVitB1
      LabsVitB2
      LabsVitB3
      LabsVitB5
      LabsVitB6
      LabsVitB7
      LabsVitB9
      LabsVitB12
      LabsVitC
      LabsVitD
      LabsVitE
      LabsVitK
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateCommunity = /* GraphQL */ `
  subscription OnCreateCommunity(
    $filter: ModelSubscriptionCommunityFilterInput
  ) {
    onCreateCommunity(filter: $filter) {
      id
      name
      category
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateCommunity = /* GraphQL */ `
  subscription OnUpdateCommunity(
    $filter: ModelSubscriptionCommunityFilterInput
  ) {
    onUpdateCommunity(filter: $filter) {
      id
      name
      category
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteCommunity = /* GraphQL */ `
  subscription OnDeleteCommunity(
    $filter: ModelSubscriptionCommunityFilterInput
  ) {
    onDeleteCommunity(filter: $filter) {
      id
      name
      category
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateCommunityMembership = /* GraphQL */ `
  subscription OnCreateCommunityMembership(
    $filter: ModelSubscriptionCommunityMembershipFilterInput
    $owner: String
  ) {
    onCreateCommunityMembership(filter: $filter, owner: $owner) {
      id
      owner
      userID
      communityID
      role
      joinedAt
      leftAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCommunityMembership = /* GraphQL */ `
  subscription OnUpdateCommunityMembership(
    $filter: ModelSubscriptionCommunityMembershipFilterInput
    $owner: String
  ) {
    onUpdateCommunityMembership(filter: $filter, owner: $owner) {
      id
      owner
      userID
      communityID
      role
      joinedAt
      leftAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCommunityMembership = /* GraphQL */ `
  subscription OnDeleteCommunityMembership(
    $filter: ModelSubscriptionCommunityMembershipFilterInput
    $owner: String
  ) {
    onDeleteCommunityMembership(filter: $filter, owner: $owner) {
      id
      owner
      userID
      communityID
      role
      joinedAt
      leftAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCommunityActivity = /* GraphQL */ `
  subscription OnCreateCommunityActivity(
    $filter: ModelSubscriptionCommunityActivityFilterInput
    $owner: String
  ) {
    onCreateCommunityActivity(filter: $filter, owner: $owner) {
      id
      userID
      communities
      actionName
      text
      formattedText
      imageURLs
      videoURLs
      documentURLs
      visibility
      threadID
      monthIndex
      createdAt
      updatedAt
      containsUnsafeContent
      sentimentScore
      engagementCount
      owner
      __typename
    }
  }
`;
export const onUpdateCommunityActivity = /* GraphQL */ `
  subscription OnUpdateCommunityActivity(
    $filter: ModelSubscriptionCommunityActivityFilterInput
    $owner: String
  ) {
    onUpdateCommunityActivity(filter: $filter, owner: $owner) {
      id
      userID
      communities
      actionName
      text
      formattedText
      imageURLs
      videoURLs
      documentURLs
      visibility
      threadID
      monthIndex
      createdAt
      updatedAt
      containsUnsafeContent
      sentimentScore
      engagementCount
      owner
      __typename
    }
  }
`;
export const onDeleteCommunityActivity = /* GraphQL */ `
  subscription OnDeleteCommunityActivity(
    $filter: ModelSubscriptionCommunityActivityFilterInput
    $owner: String
  ) {
    onDeleteCommunityActivity(filter: $filter, owner: $owner) {
      id
      userID
      communities
      actionName
      text
      formattedText
      imageURLs
      videoURLs
      documentURLs
      visibility
      threadID
      monthIndex
      createdAt
      updatedAt
      containsUnsafeContent
      sentimentScore
      engagementCount
      owner
      __typename
    }
  }
`;
export const onCreatePersonalProgress = /* GraphQL */ `
  subscription OnCreatePersonalProgress(
    $filter: ModelSubscriptionPersonalProgressFilterInput
    $owner: String
  ) {
    onCreatePersonalProgress(filter: $filter, owner: $owner) {
      id
      userID
      year
      journeyYearStartMonth
      month01Leaves
      month02Leaves
      month03Leaves
      month04Leaves
      month05Leaves
      month06Leaves
      month07Leaves
      month08Leaves
      month09Leaves
      month10Leaves
      month11Leaves
      month12Leaves
      month01Flowers
      month02Flowers
      month03Flowers
      month04Flowers
      month05Flowers
      month06Flowers
      month07Flowers
      month08Flowers
      month09Flowers
      month10Flowers
      month11Flowers
      month12Flowers
      month01Fruit
      month02Fruit
      month03Fruit
      month04Fruit
      month05Fruit
      month06Fruit
      month07Fruit
      month08Fruit
      month09Fruit
      month10Fruit
      month11Fruit
      month12Fruit
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdatePersonalProgress = /* GraphQL */ `
  subscription OnUpdatePersonalProgress(
    $filter: ModelSubscriptionPersonalProgressFilterInput
    $owner: String
  ) {
    onUpdatePersonalProgress(filter: $filter, owner: $owner) {
      id
      userID
      year
      journeyYearStartMonth
      month01Leaves
      month02Leaves
      month03Leaves
      month04Leaves
      month05Leaves
      month06Leaves
      month07Leaves
      month08Leaves
      month09Leaves
      month10Leaves
      month11Leaves
      month12Leaves
      month01Flowers
      month02Flowers
      month03Flowers
      month04Flowers
      month05Flowers
      month06Flowers
      month07Flowers
      month08Flowers
      month09Flowers
      month10Flowers
      month11Flowers
      month12Flowers
      month01Fruit
      month02Fruit
      month03Fruit
      month04Fruit
      month05Fruit
      month06Fruit
      month07Fruit
      month08Fruit
      month09Fruit
      month10Fruit
      month11Fruit
      month12Fruit
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeletePersonalProgress = /* GraphQL */ `
  subscription OnDeletePersonalProgress(
    $filter: ModelSubscriptionPersonalProgressFilterInput
    $owner: String
  ) {
    onDeletePersonalProgress(filter: $filter, owner: $owner) {
      id
      userID
      year
      journeyYearStartMonth
      month01Leaves
      month02Leaves
      month03Leaves
      month04Leaves
      month05Leaves
      month06Leaves
      month07Leaves
      month08Leaves
      month09Leaves
      month10Leaves
      month11Leaves
      month12Leaves
      month01Flowers
      month02Flowers
      month03Flowers
      month04Flowers
      month05Flowers
      month06Flowers
      month07Flowers
      month08Flowers
      month09Flowers
      month10Flowers
      month11Flowers
      month12Flowers
      month01Fruit
      month02Fruit
      month03Fruit
      month04Fruit
      month05Fruit
      month06Fruit
      month07Fruit
      month08Fruit
      month09Fruit
      month10Fruit
      month11Fruit
      month12Fruit
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateThread = /* GraphQL */ `
  subscription OnCreateThread(
    $filter: ModelSubscriptionThreadFilterInput
    $owner: String
  ) {
    onCreateThread(filter: $filter, owner: $owner) {
      id
      userID
      actionName
      isPrivate
      communities
      posts {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateThread = /* GraphQL */ `
  subscription OnUpdateThread(
    $filter: ModelSubscriptionThreadFilterInput
    $owner: String
  ) {
    onUpdateThread(filter: $filter, owner: $owner) {
      id
      userID
      actionName
      isPrivate
      communities
      posts {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteThread = /* GraphQL */ `
  subscription OnDeleteThread(
    $filter: ModelSubscriptionThreadFilterInput
    $owner: String
  ) {
    onDeleteThread(filter: $filter, owner: $owner) {
      id
      userID
      actionName
      isPrivate
      communities
      posts {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateThreadPost = /* GraphQL */ `
  subscription OnCreateThreadPost(
    $filter: ModelSubscriptionThreadPostFilterInput
    $owner: String
  ) {
    onCreateThreadPost(filter: $filter, owner: $owner) {
      id
      threadID
      userID
      text
      imageURLs
      communities
      visibility
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateThreadPost = /* GraphQL */ `
  subscription OnUpdateThreadPost(
    $filter: ModelSubscriptionThreadPostFilterInput
    $owner: String
  ) {
    onUpdateThreadPost(filter: $filter, owner: $owner) {
      id
      threadID
      userID
      text
      imageURLs
      communities
      visibility
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteThreadPost = /* GraphQL */ `
  subscription OnDeleteThreadPost(
    $filter: ModelSubscriptionThreadPostFilterInput
    $owner: String
  ) {
    onDeleteThreadPost(filter: $filter, owner: $owner) {
      id
      threadID
      userID
      text
      imageURLs
      communities
      visibility
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateUpliftEvent = /* GraphQL */ `
  subscription OnCreateUpliftEvent(
    $filter: ModelSubscriptionUpliftEventFilterInput
    $owner: String
  ) {
    onCreateUpliftEvent(filter: $filter, owner: $owner) {
      id
      userID
      postID
      emoji
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onUpdateUpliftEvent = /* GraphQL */ `
  subscription OnUpdateUpliftEvent(
    $filter: ModelSubscriptionUpliftEventFilterInput
    $owner: String
  ) {
    onUpdateUpliftEvent(filter: $filter, owner: $owner) {
      id
      userID
      postID
      emoji
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onDeleteUpliftEvent = /* GraphQL */ `
  subscription OnDeleteUpliftEvent(
    $filter: ModelSubscriptionUpliftEventFilterInput
    $owner: String
  ) {
    onDeleteUpliftEvent(filter: $filter, owner: $owner) {
      id
      userID
      postID
      emoji
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const onCreateLoginGeneralInformation = /* GraphQL */ `
  subscription OnCreateLoginGeneralInformation(
    $filter: ModelSubscriptionLoginGeneralInformationFilterInput
    $owner: String
    $organizationId: String
  ) {
    onCreateLoginGeneralInformation(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      loginId
      generalInformationId
      login {
        id
        Email
        Password
        LoginDate
        LoginTime
        ProfileType
        createdAt
        updatedAt
        __typename
      }
      generalInformation {
        id
        userId
        organizationId
        FirstName
        LastName
        Email
        ProfessionalRole
        BusinessName
        BusinessEIN
        BusinessCountry
        BusinessAddress
        BusinessCity
        BusinessState
        BusinessZipCode
        BusinessPhoneNumber
        BusinessWebsite
        OrganizationAdministrator
        OrganizationEmployee
        Department
        Service
        ProgramsUnit
        ProfileType
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onUpdateLoginGeneralInformation = /* GraphQL */ `
  subscription OnUpdateLoginGeneralInformation(
    $filter: ModelSubscriptionLoginGeneralInformationFilterInput
    $owner: String
    $organizationId: String
  ) {
    onUpdateLoginGeneralInformation(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      loginId
      generalInformationId
      login {
        id
        Email
        Password
        LoginDate
        LoginTime
        ProfileType
        createdAt
        updatedAt
        __typename
      }
      generalInformation {
        id
        userId
        organizationId
        FirstName
        LastName
        Email
        ProfessionalRole
        BusinessName
        BusinessEIN
        BusinessCountry
        BusinessAddress
        BusinessCity
        BusinessState
        BusinessZipCode
        BusinessPhoneNumber
        BusinessWebsite
        OrganizationAdministrator
        OrganizationEmployee
        Department
        Service
        ProgramsUnit
        ProfileType
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onDeleteLoginGeneralInformation = /* GraphQL */ `
  subscription OnDeleteLoginGeneralInformation(
    $filter: ModelSubscriptionLoginGeneralInformationFilterInput
    $owner: String
    $organizationId: String
  ) {
    onDeleteLoginGeneralInformation(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      loginId
      generalInformationId
      login {
        id
        Email
        Password
        LoginDate
        LoginTime
        ProfileType
        createdAt
        updatedAt
        __typename
      }
      generalInformation {
        id
        userId
        organizationId
        FirstName
        LastName
        Email
        ProfessionalRole
        BusinessName
        BusinessEIN
        BusinessCountry
        BusinessAddress
        BusinessCity
        BusinessState
        BusinessZipCode
        BusinessPhoneNumber
        BusinessWebsite
        OrganizationAdministrator
        OrganizationEmployee
        Department
        Service
        ProgramsUnit
        ProfileType
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onCreateGeneralInformationTrackPlan = /* GraphQL */ `
  subscription OnCreateGeneralInformationTrackPlan(
    $filter: ModelSubscriptionGeneralInformationTrackPlanFilterInput
    $owner: String
    $organizationId: String
  ) {
    onCreateGeneralInformationTrackPlan(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      generalInformationId
      trackPlanId
      generalInformation {
        id
        userId
        organizationId
        FirstName
        LastName
        Email
        ProfessionalRole
        BusinessName
        BusinessEIN
        BusinessCountry
        BusinessAddress
        BusinessCity
        BusinessState
        BusinessZipCode
        BusinessPhoneNumber
        BusinessWebsite
        OrganizationAdministrator
        OrganizationEmployee
        Department
        Service
        ProgramsUnit
        ProfileType
        createdAt
        updatedAt
        owner
        __typename
      }
      trackPlan {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        ActionDomain
        ActionQuestion
        Action
        Frequency
        ActionNote
        Update1Points
        Update1Note
        Update1Date
        Update2Points
        Update2Note
        Update2Date
        Update3Points
        Update3Note
        Update3Date
        Update4Points
        Update4Note
        Update4Date
        Update5Points
        Update5Note
        Update5Date
        Update6Points
        Update6Note
        Update6Date
        Update7Points
        Update7Note
        Update7Date
        Update8Points
        Update8Note
        Update8Date
        Percentage
        Discontinued
        DiscontinuedDate
        Successful
        SuccessfulDate
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onUpdateGeneralInformationTrackPlan = /* GraphQL */ `
  subscription OnUpdateGeneralInformationTrackPlan(
    $filter: ModelSubscriptionGeneralInformationTrackPlanFilterInput
    $owner: String
    $organizationId: String
  ) {
    onUpdateGeneralInformationTrackPlan(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      generalInformationId
      trackPlanId
      generalInformation {
        id
        userId
        organizationId
        FirstName
        LastName
        Email
        ProfessionalRole
        BusinessName
        BusinessEIN
        BusinessCountry
        BusinessAddress
        BusinessCity
        BusinessState
        BusinessZipCode
        BusinessPhoneNumber
        BusinessWebsite
        OrganizationAdministrator
        OrganizationEmployee
        Department
        Service
        ProgramsUnit
        ProfileType
        createdAt
        updatedAt
        owner
        __typename
      }
      trackPlan {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        ActionDomain
        ActionQuestion
        Action
        Frequency
        ActionNote
        Update1Points
        Update1Note
        Update1Date
        Update2Points
        Update2Note
        Update2Date
        Update3Points
        Update3Note
        Update3Date
        Update4Points
        Update4Note
        Update4Date
        Update5Points
        Update5Note
        Update5Date
        Update6Points
        Update6Note
        Update6Date
        Update7Points
        Update7Note
        Update7Date
        Update8Points
        Update8Note
        Update8Date
        Percentage
        Discontinued
        DiscontinuedDate
        Successful
        SuccessfulDate
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onDeleteGeneralInformationTrackPlan = /* GraphQL */ `
  subscription OnDeleteGeneralInformationTrackPlan(
    $filter: ModelSubscriptionGeneralInformationTrackPlanFilterInput
    $owner: String
    $organizationId: String
  ) {
    onDeleteGeneralInformationTrackPlan(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      generalInformationId
      trackPlanId
      generalInformation {
        id
        userId
        organizationId
        FirstName
        LastName
        Email
        ProfessionalRole
        BusinessName
        BusinessEIN
        BusinessCountry
        BusinessAddress
        BusinessCity
        BusinessState
        BusinessZipCode
        BusinessPhoneNumber
        BusinessWebsite
        OrganizationAdministrator
        OrganizationEmployee
        Department
        Service
        ProgramsUnit
        ProfileType
        createdAt
        updatedAt
        owner
        __typename
      }
      trackPlan {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        ActionDomain
        ActionQuestion
        Action
        Frequency
        ActionNote
        Update1Points
        Update1Note
        Update1Date
        Update2Points
        Update2Note
        Update2Date
        Update3Points
        Update3Note
        Update3Date
        Update4Points
        Update4Note
        Update4Date
        Update5Points
        Update5Note
        Update5Date
        Update6Points
        Update6Note
        Update6Date
        Update7Points
        Update7Note
        Update7Date
        Update8Points
        Update8Note
        Update8Date
        Percentage
        Discontinued
        DiscontinuedDate
        Successful
        SuccessfulDate
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onCreateGeneralInformationAssessmentAnswers = /* GraphQL */ `
  subscription OnCreateGeneralInformationAssessmentAnswers(
    $filter: ModelSubscriptionGeneralInformationAssessmentAnswersFilterInput
    $owner: String
    $organizationId: String
  ) {
    onCreateGeneralInformationAssessmentAnswers(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      generalInformationId
      assessmentAnswersId
      generalInformation {
        id
        userId
        organizationId
        FirstName
        LastName
        Email
        ProfessionalRole
        BusinessName
        BusinessEIN
        BusinessCountry
        BusinessAddress
        BusinessCity
        BusinessState
        BusinessZipCode
        BusinessPhoneNumber
        BusinessWebsite
        OrganizationAdministrator
        OrganizationEmployee
        Department
        Service
        ProgramsUnit
        ProfileType
        createdAt
        updatedAt
        owner
        __typename
      }
      assessmentAnswers {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        TRHurtfulNames
        TRNoNurturing
        TRHit
        TRNeedsNotMet
        TRForcedSex
        TRResponsible
        TRViolence
        TRSubstanceAbuse
        TRMentalIllness
        TRParentDivorce
        TRParentIncarcerated
        TRHomelessness
        TRBodyFunction
        TRNaturalDisaster
        TRDirectTerrorism
        TRIndirectTerrorism
        TRLovedOne
        TRBelief
        TRResponseProfessional
        TRResponseFamilyFriend
        TRResponseGod
        TRResponseNoOne
        TRNoTrauma
        CMAlcohol
        CMDrugs
        CMOvereating
        CMSmoking
        CMGaming
        CMShopping
        CMGambling
        CMSex
        CMPorn
        CMBlaming
        CMHurting
        CMDisengage
        CMArt
        CMMusic
        CMPoetry
        CMReading
        CMGroups
        CMCounseling
        CMVenting
        CMWriting
        CMSensory
        CMDancing
        CMExercising
        CMWalking
        CMChange
        CMAnalyze
        CMDaydream
        CMPositive
        MHDxPTSD
        MHDxDepression
        MHDxSUD
        MHDxOtherMental
        MHSleeplessness
        MHAlcoholUse
        MHAnxiety
        MHDepression
        MHDrugUse
        MHGrief
        MHGuilt
        MHIrritability
        MHStress
        MHRegret
        MHSuicidalThoughts
        MHLoneliness
        MHWorry
        PHDxInfertility
        PHDxCurableSTD
        PHDxIncurableSTD
        PHDxCancer
        PHDxDiabetes
        PHDxHighBlood
        PHDxHeartDisease
        PHDxIrritableBowel
        PHDxVitA
        PHDxVitB
        PHDxVitC
        PHDxVitD
        PHDxVitE
        PHDxVitK
        PHDxAutoimmune
        PHDxOtherPhysical
        PHVegeFruits
        PHBeanLentils
        PHGrainBreads
        PHDairy
        PHMeat
        PHFishSeafood
        PHSweets
        PHWater
        PHPhysicalActivity
        SHSpiritualDefine
        SHSpiritualIntegrate
        SHPrayer
        SHSpiritualActivity
        SHReadText
        SHAlignText
        SHCommunity
        MHHope
        MHPeace
        SoHLearning
        MHJoy
        SoHStable
        SoHSafety
        SoHKindness
        SoHForgiveness
        SoHPatience
        SoHRelationships
        SoHContribution
        SoHBoundaries
        SoHEUnpleasant
        SoHEPleasant
        SoHEControl
        SDoHAgeRange
        SDoHRace
        SDoHGeographicRegion
        SDoHEthnicity
        SDoHState
        SDoHZipCode
        SDoHMaritalStatus
        SDoHMilitaryStatus
        SDoHGender
        SDoHEducation
        SDoHJobStatus
        SDoHIncome
        SDoHHousingStatus
        SDoHHomeAsChild
        SDoHReligion
        SDoHDenomination
        isActive
        SHSkip
        ProAssessmentFinalizedReview1
        ProAssessmentFinalizedReviewDate1
        ProAssessmentFinalizedName1
        ProAssessmentFinalizedRole1
        ProAssessmentFinalizedReview2
        ProAssessmentFinalizedReviewDate2
        ProAssessmentFinalizedName2
        ProAssessmentFinalizedRole2
        ProAssessmentFinalizedReview3
        ProAssessmentFinalizedReviewDate3
        ProAssessmentFinalizedName3
        ProAssessmentFinalizedRole3
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onUpdateGeneralInformationAssessmentAnswers = /* GraphQL */ `
  subscription OnUpdateGeneralInformationAssessmentAnswers(
    $filter: ModelSubscriptionGeneralInformationAssessmentAnswersFilterInput
    $owner: String
    $organizationId: String
  ) {
    onUpdateGeneralInformationAssessmentAnswers(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      generalInformationId
      assessmentAnswersId
      generalInformation {
        id
        userId
        organizationId
        FirstName
        LastName
        Email
        ProfessionalRole
        BusinessName
        BusinessEIN
        BusinessCountry
        BusinessAddress
        BusinessCity
        BusinessState
        BusinessZipCode
        BusinessPhoneNumber
        BusinessWebsite
        OrganizationAdministrator
        OrganizationEmployee
        Department
        Service
        ProgramsUnit
        ProfileType
        createdAt
        updatedAt
        owner
        __typename
      }
      assessmentAnswers {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        TRHurtfulNames
        TRNoNurturing
        TRHit
        TRNeedsNotMet
        TRForcedSex
        TRResponsible
        TRViolence
        TRSubstanceAbuse
        TRMentalIllness
        TRParentDivorce
        TRParentIncarcerated
        TRHomelessness
        TRBodyFunction
        TRNaturalDisaster
        TRDirectTerrorism
        TRIndirectTerrorism
        TRLovedOne
        TRBelief
        TRResponseProfessional
        TRResponseFamilyFriend
        TRResponseGod
        TRResponseNoOne
        TRNoTrauma
        CMAlcohol
        CMDrugs
        CMOvereating
        CMSmoking
        CMGaming
        CMShopping
        CMGambling
        CMSex
        CMPorn
        CMBlaming
        CMHurting
        CMDisengage
        CMArt
        CMMusic
        CMPoetry
        CMReading
        CMGroups
        CMCounseling
        CMVenting
        CMWriting
        CMSensory
        CMDancing
        CMExercising
        CMWalking
        CMChange
        CMAnalyze
        CMDaydream
        CMPositive
        MHDxPTSD
        MHDxDepression
        MHDxSUD
        MHDxOtherMental
        MHSleeplessness
        MHAlcoholUse
        MHAnxiety
        MHDepression
        MHDrugUse
        MHGrief
        MHGuilt
        MHIrritability
        MHStress
        MHRegret
        MHSuicidalThoughts
        MHLoneliness
        MHWorry
        PHDxInfertility
        PHDxCurableSTD
        PHDxIncurableSTD
        PHDxCancer
        PHDxDiabetes
        PHDxHighBlood
        PHDxHeartDisease
        PHDxIrritableBowel
        PHDxVitA
        PHDxVitB
        PHDxVitC
        PHDxVitD
        PHDxVitE
        PHDxVitK
        PHDxAutoimmune
        PHDxOtherPhysical
        PHVegeFruits
        PHBeanLentils
        PHGrainBreads
        PHDairy
        PHMeat
        PHFishSeafood
        PHSweets
        PHWater
        PHPhysicalActivity
        SHSpiritualDefine
        SHSpiritualIntegrate
        SHPrayer
        SHSpiritualActivity
        SHReadText
        SHAlignText
        SHCommunity
        MHHope
        MHPeace
        SoHLearning
        MHJoy
        SoHStable
        SoHSafety
        SoHKindness
        SoHForgiveness
        SoHPatience
        SoHRelationships
        SoHContribution
        SoHBoundaries
        SoHEUnpleasant
        SoHEPleasant
        SoHEControl
        SDoHAgeRange
        SDoHRace
        SDoHGeographicRegion
        SDoHEthnicity
        SDoHState
        SDoHZipCode
        SDoHMaritalStatus
        SDoHMilitaryStatus
        SDoHGender
        SDoHEducation
        SDoHJobStatus
        SDoHIncome
        SDoHHousingStatus
        SDoHHomeAsChild
        SDoHReligion
        SDoHDenomination
        isActive
        SHSkip
        ProAssessmentFinalizedReview1
        ProAssessmentFinalizedReviewDate1
        ProAssessmentFinalizedName1
        ProAssessmentFinalizedRole1
        ProAssessmentFinalizedReview2
        ProAssessmentFinalizedReviewDate2
        ProAssessmentFinalizedName2
        ProAssessmentFinalizedRole2
        ProAssessmentFinalizedReview3
        ProAssessmentFinalizedReviewDate3
        ProAssessmentFinalizedName3
        ProAssessmentFinalizedRole3
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onDeleteGeneralInformationAssessmentAnswers = /* GraphQL */ `
  subscription OnDeleteGeneralInformationAssessmentAnswers(
    $filter: ModelSubscriptionGeneralInformationAssessmentAnswersFilterInput
    $owner: String
    $organizationId: String
  ) {
    onDeleteGeneralInformationAssessmentAnswers(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      generalInformationId
      assessmentAnswersId
      generalInformation {
        id
        userId
        organizationId
        FirstName
        LastName
        Email
        ProfessionalRole
        BusinessName
        BusinessEIN
        BusinessCountry
        BusinessAddress
        BusinessCity
        BusinessState
        BusinessZipCode
        BusinessPhoneNumber
        BusinessWebsite
        OrganizationAdministrator
        OrganizationEmployee
        Department
        Service
        ProgramsUnit
        ProfileType
        createdAt
        updatedAt
        owner
        __typename
      }
      assessmentAnswers {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        TRHurtfulNames
        TRNoNurturing
        TRHit
        TRNeedsNotMet
        TRForcedSex
        TRResponsible
        TRViolence
        TRSubstanceAbuse
        TRMentalIllness
        TRParentDivorce
        TRParentIncarcerated
        TRHomelessness
        TRBodyFunction
        TRNaturalDisaster
        TRDirectTerrorism
        TRIndirectTerrorism
        TRLovedOne
        TRBelief
        TRResponseProfessional
        TRResponseFamilyFriend
        TRResponseGod
        TRResponseNoOne
        TRNoTrauma
        CMAlcohol
        CMDrugs
        CMOvereating
        CMSmoking
        CMGaming
        CMShopping
        CMGambling
        CMSex
        CMPorn
        CMBlaming
        CMHurting
        CMDisengage
        CMArt
        CMMusic
        CMPoetry
        CMReading
        CMGroups
        CMCounseling
        CMVenting
        CMWriting
        CMSensory
        CMDancing
        CMExercising
        CMWalking
        CMChange
        CMAnalyze
        CMDaydream
        CMPositive
        MHDxPTSD
        MHDxDepression
        MHDxSUD
        MHDxOtherMental
        MHSleeplessness
        MHAlcoholUse
        MHAnxiety
        MHDepression
        MHDrugUse
        MHGrief
        MHGuilt
        MHIrritability
        MHStress
        MHRegret
        MHSuicidalThoughts
        MHLoneliness
        MHWorry
        PHDxInfertility
        PHDxCurableSTD
        PHDxIncurableSTD
        PHDxCancer
        PHDxDiabetes
        PHDxHighBlood
        PHDxHeartDisease
        PHDxIrritableBowel
        PHDxVitA
        PHDxVitB
        PHDxVitC
        PHDxVitD
        PHDxVitE
        PHDxVitK
        PHDxAutoimmune
        PHDxOtherPhysical
        PHVegeFruits
        PHBeanLentils
        PHGrainBreads
        PHDairy
        PHMeat
        PHFishSeafood
        PHSweets
        PHWater
        PHPhysicalActivity
        SHSpiritualDefine
        SHSpiritualIntegrate
        SHPrayer
        SHSpiritualActivity
        SHReadText
        SHAlignText
        SHCommunity
        MHHope
        MHPeace
        SoHLearning
        MHJoy
        SoHStable
        SoHSafety
        SoHKindness
        SoHForgiveness
        SoHPatience
        SoHRelationships
        SoHContribution
        SoHBoundaries
        SoHEUnpleasant
        SoHEPleasant
        SoHEControl
        SDoHAgeRange
        SDoHRace
        SDoHGeographicRegion
        SDoHEthnicity
        SDoHState
        SDoHZipCode
        SDoHMaritalStatus
        SDoHMilitaryStatus
        SDoHGender
        SDoHEducation
        SDoHJobStatus
        SDoHIncome
        SDoHHousingStatus
        SDoHHomeAsChild
        SDoHReligion
        SDoHDenomination
        isActive
        SHSkip
        ProAssessmentFinalizedReview1
        ProAssessmentFinalizedReviewDate1
        ProAssessmentFinalizedName1
        ProAssessmentFinalizedRole1
        ProAssessmentFinalizedReview2
        ProAssessmentFinalizedReviewDate2
        ProAssessmentFinalizedName2
        ProAssessmentFinalizedRole2
        ProAssessmentFinalizedReview3
        ProAssessmentFinalizedReviewDate3
        ProAssessmentFinalizedName3
        ProAssessmentFinalizedRole3
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onCreateAssessmentAnswersTrackPlan = /* GraphQL */ `
  subscription OnCreateAssessmentAnswersTrackPlan(
    $filter: ModelSubscriptionAssessmentAnswersTrackPlanFilterInput
    $owner: String
    $organizationId: String
  ) {
    onCreateAssessmentAnswersTrackPlan(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      assessmentAnswersId
      trackPlanId
      assessmentAnswers {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        TRHurtfulNames
        TRNoNurturing
        TRHit
        TRNeedsNotMet
        TRForcedSex
        TRResponsible
        TRViolence
        TRSubstanceAbuse
        TRMentalIllness
        TRParentDivorce
        TRParentIncarcerated
        TRHomelessness
        TRBodyFunction
        TRNaturalDisaster
        TRDirectTerrorism
        TRIndirectTerrorism
        TRLovedOne
        TRBelief
        TRResponseProfessional
        TRResponseFamilyFriend
        TRResponseGod
        TRResponseNoOne
        TRNoTrauma
        CMAlcohol
        CMDrugs
        CMOvereating
        CMSmoking
        CMGaming
        CMShopping
        CMGambling
        CMSex
        CMPorn
        CMBlaming
        CMHurting
        CMDisengage
        CMArt
        CMMusic
        CMPoetry
        CMReading
        CMGroups
        CMCounseling
        CMVenting
        CMWriting
        CMSensory
        CMDancing
        CMExercising
        CMWalking
        CMChange
        CMAnalyze
        CMDaydream
        CMPositive
        MHDxPTSD
        MHDxDepression
        MHDxSUD
        MHDxOtherMental
        MHSleeplessness
        MHAlcoholUse
        MHAnxiety
        MHDepression
        MHDrugUse
        MHGrief
        MHGuilt
        MHIrritability
        MHStress
        MHRegret
        MHSuicidalThoughts
        MHLoneliness
        MHWorry
        PHDxInfertility
        PHDxCurableSTD
        PHDxIncurableSTD
        PHDxCancer
        PHDxDiabetes
        PHDxHighBlood
        PHDxHeartDisease
        PHDxIrritableBowel
        PHDxVitA
        PHDxVitB
        PHDxVitC
        PHDxVitD
        PHDxVitE
        PHDxVitK
        PHDxAutoimmune
        PHDxOtherPhysical
        PHVegeFruits
        PHBeanLentils
        PHGrainBreads
        PHDairy
        PHMeat
        PHFishSeafood
        PHSweets
        PHWater
        PHPhysicalActivity
        SHSpiritualDefine
        SHSpiritualIntegrate
        SHPrayer
        SHSpiritualActivity
        SHReadText
        SHAlignText
        SHCommunity
        MHHope
        MHPeace
        SoHLearning
        MHJoy
        SoHStable
        SoHSafety
        SoHKindness
        SoHForgiveness
        SoHPatience
        SoHRelationships
        SoHContribution
        SoHBoundaries
        SoHEUnpleasant
        SoHEPleasant
        SoHEControl
        SDoHAgeRange
        SDoHRace
        SDoHGeographicRegion
        SDoHEthnicity
        SDoHState
        SDoHZipCode
        SDoHMaritalStatus
        SDoHMilitaryStatus
        SDoHGender
        SDoHEducation
        SDoHJobStatus
        SDoHIncome
        SDoHHousingStatus
        SDoHHomeAsChild
        SDoHReligion
        SDoHDenomination
        isActive
        SHSkip
        ProAssessmentFinalizedReview1
        ProAssessmentFinalizedReviewDate1
        ProAssessmentFinalizedName1
        ProAssessmentFinalizedRole1
        ProAssessmentFinalizedReview2
        ProAssessmentFinalizedReviewDate2
        ProAssessmentFinalizedName2
        ProAssessmentFinalizedRole2
        ProAssessmentFinalizedReview3
        ProAssessmentFinalizedReviewDate3
        ProAssessmentFinalizedName3
        ProAssessmentFinalizedRole3
        createdAt
        updatedAt
        owner
        __typename
      }
      trackPlan {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        ActionDomain
        ActionQuestion
        Action
        Frequency
        ActionNote
        Update1Points
        Update1Note
        Update1Date
        Update2Points
        Update2Note
        Update2Date
        Update3Points
        Update3Note
        Update3Date
        Update4Points
        Update4Note
        Update4Date
        Update5Points
        Update5Note
        Update5Date
        Update6Points
        Update6Note
        Update6Date
        Update7Points
        Update7Note
        Update7Date
        Update8Points
        Update8Note
        Update8Date
        Percentage
        Discontinued
        DiscontinuedDate
        Successful
        SuccessfulDate
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onUpdateAssessmentAnswersTrackPlan = /* GraphQL */ `
  subscription OnUpdateAssessmentAnswersTrackPlan(
    $filter: ModelSubscriptionAssessmentAnswersTrackPlanFilterInput
    $owner: String
    $organizationId: String
  ) {
    onUpdateAssessmentAnswersTrackPlan(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      assessmentAnswersId
      trackPlanId
      assessmentAnswers {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        TRHurtfulNames
        TRNoNurturing
        TRHit
        TRNeedsNotMet
        TRForcedSex
        TRResponsible
        TRViolence
        TRSubstanceAbuse
        TRMentalIllness
        TRParentDivorce
        TRParentIncarcerated
        TRHomelessness
        TRBodyFunction
        TRNaturalDisaster
        TRDirectTerrorism
        TRIndirectTerrorism
        TRLovedOne
        TRBelief
        TRResponseProfessional
        TRResponseFamilyFriend
        TRResponseGod
        TRResponseNoOne
        TRNoTrauma
        CMAlcohol
        CMDrugs
        CMOvereating
        CMSmoking
        CMGaming
        CMShopping
        CMGambling
        CMSex
        CMPorn
        CMBlaming
        CMHurting
        CMDisengage
        CMArt
        CMMusic
        CMPoetry
        CMReading
        CMGroups
        CMCounseling
        CMVenting
        CMWriting
        CMSensory
        CMDancing
        CMExercising
        CMWalking
        CMChange
        CMAnalyze
        CMDaydream
        CMPositive
        MHDxPTSD
        MHDxDepression
        MHDxSUD
        MHDxOtherMental
        MHSleeplessness
        MHAlcoholUse
        MHAnxiety
        MHDepression
        MHDrugUse
        MHGrief
        MHGuilt
        MHIrritability
        MHStress
        MHRegret
        MHSuicidalThoughts
        MHLoneliness
        MHWorry
        PHDxInfertility
        PHDxCurableSTD
        PHDxIncurableSTD
        PHDxCancer
        PHDxDiabetes
        PHDxHighBlood
        PHDxHeartDisease
        PHDxIrritableBowel
        PHDxVitA
        PHDxVitB
        PHDxVitC
        PHDxVitD
        PHDxVitE
        PHDxVitK
        PHDxAutoimmune
        PHDxOtherPhysical
        PHVegeFruits
        PHBeanLentils
        PHGrainBreads
        PHDairy
        PHMeat
        PHFishSeafood
        PHSweets
        PHWater
        PHPhysicalActivity
        SHSpiritualDefine
        SHSpiritualIntegrate
        SHPrayer
        SHSpiritualActivity
        SHReadText
        SHAlignText
        SHCommunity
        MHHope
        MHPeace
        SoHLearning
        MHJoy
        SoHStable
        SoHSafety
        SoHKindness
        SoHForgiveness
        SoHPatience
        SoHRelationships
        SoHContribution
        SoHBoundaries
        SoHEUnpleasant
        SoHEPleasant
        SoHEControl
        SDoHAgeRange
        SDoHRace
        SDoHGeographicRegion
        SDoHEthnicity
        SDoHState
        SDoHZipCode
        SDoHMaritalStatus
        SDoHMilitaryStatus
        SDoHGender
        SDoHEducation
        SDoHJobStatus
        SDoHIncome
        SDoHHousingStatus
        SDoHHomeAsChild
        SDoHReligion
        SDoHDenomination
        isActive
        SHSkip
        ProAssessmentFinalizedReview1
        ProAssessmentFinalizedReviewDate1
        ProAssessmentFinalizedName1
        ProAssessmentFinalizedRole1
        ProAssessmentFinalizedReview2
        ProAssessmentFinalizedReviewDate2
        ProAssessmentFinalizedName2
        ProAssessmentFinalizedRole2
        ProAssessmentFinalizedReview3
        ProAssessmentFinalizedReviewDate3
        ProAssessmentFinalizedName3
        ProAssessmentFinalizedRole3
        createdAt
        updatedAt
        owner
        __typename
      }
      trackPlan {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        ActionDomain
        ActionQuestion
        Action
        Frequency
        ActionNote
        Update1Points
        Update1Note
        Update1Date
        Update2Points
        Update2Note
        Update2Date
        Update3Points
        Update3Note
        Update3Date
        Update4Points
        Update4Note
        Update4Date
        Update5Points
        Update5Note
        Update5Date
        Update6Points
        Update6Note
        Update6Date
        Update7Points
        Update7Note
        Update7Date
        Update8Points
        Update8Note
        Update8Date
        Percentage
        Discontinued
        DiscontinuedDate
        Successful
        SuccessfulDate
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
export const onDeleteAssessmentAnswersTrackPlan = /* GraphQL */ `
  subscription OnDeleteAssessmentAnswersTrackPlan(
    $filter: ModelSubscriptionAssessmentAnswersTrackPlanFilterInput
    $owner: String
    $organizationId: String
  ) {
    onDeleteAssessmentAnswersTrackPlan(
      filter: $filter
      owner: $owner
      organizationId: $organizationId
    ) {
      id
      assessmentAnswersId
      trackPlanId
      assessmentAnswers {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        TRHurtfulNames
        TRNoNurturing
        TRHit
        TRNeedsNotMet
        TRForcedSex
        TRResponsible
        TRViolence
        TRSubstanceAbuse
        TRMentalIllness
        TRParentDivorce
        TRParentIncarcerated
        TRHomelessness
        TRBodyFunction
        TRNaturalDisaster
        TRDirectTerrorism
        TRIndirectTerrorism
        TRLovedOne
        TRBelief
        TRResponseProfessional
        TRResponseFamilyFriend
        TRResponseGod
        TRResponseNoOne
        TRNoTrauma
        CMAlcohol
        CMDrugs
        CMOvereating
        CMSmoking
        CMGaming
        CMShopping
        CMGambling
        CMSex
        CMPorn
        CMBlaming
        CMHurting
        CMDisengage
        CMArt
        CMMusic
        CMPoetry
        CMReading
        CMGroups
        CMCounseling
        CMVenting
        CMWriting
        CMSensory
        CMDancing
        CMExercising
        CMWalking
        CMChange
        CMAnalyze
        CMDaydream
        CMPositive
        MHDxPTSD
        MHDxDepression
        MHDxSUD
        MHDxOtherMental
        MHSleeplessness
        MHAlcoholUse
        MHAnxiety
        MHDepression
        MHDrugUse
        MHGrief
        MHGuilt
        MHIrritability
        MHStress
        MHRegret
        MHSuicidalThoughts
        MHLoneliness
        MHWorry
        PHDxInfertility
        PHDxCurableSTD
        PHDxIncurableSTD
        PHDxCancer
        PHDxDiabetes
        PHDxHighBlood
        PHDxHeartDisease
        PHDxIrritableBowel
        PHDxVitA
        PHDxVitB
        PHDxVitC
        PHDxVitD
        PHDxVitE
        PHDxVitK
        PHDxAutoimmune
        PHDxOtherPhysical
        PHVegeFruits
        PHBeanLentils
        PHGrainBreads
        PHDairy
        PHMeat
        PHFishSeafood
        PHSweets
        PHWater
        PHPhysicalActivity
        SHSpiritualDefine
        SHSpiritualIntegrate
        SHPrayer
        SHSpiritualActivity
        SHReadText
        SHAlignText
        SHCommunity
        MHHope
        MHPeace
        SoHLearning
        MHJoy
        SoHStable
        SoHSafety
        SoHKindness
        SoHForgiveness
        SoHPatience
        SoHRelationships
        SoHContribution
        SoHBoundaries
        SoHEUnpleasant
        SoHEPleasant
        SoHEControl
        SDoHAgeRange
        SDoHRace
        SDoHGeographicRegion
        SDoHEthnicity
        SDoHState
        SDoHZipCode
        SDoHMaritalStatus
        SDoHMilitaryStatus
        SDoHGender
        SDoHEducation
        SDoHJobStatus
        SDoHIncome
        SDoHHousingStatus
        SDoHHomeAsChild
        SDoHReligion
        SDoHDenomination
        isActive
        SHSkip
        ProAssessmentFinalizedReview1
        ProAssessmentFinalizedReviewDate1
        ProAssessmentFinalizedName1
        ProAssessmentFinalizedRole1
        ProAssessmentFinalizedReview2
        ProAssessmentFinalizedReviewDate2
        ProAssessmentFinalizedName2
        ProAssessmentFinalizedRole2
        ProAssessmentFinalizedReview3
        ProAssessmentFinalizedReviewDate3
        ProAssessmentFinalizedName3
        ProAssessmentFinalizedRole3
        createdAt
        updatedAt
        owner
        __typename
      }
      trackPlan {
        id
        userId
        organizationId
        CompletedDate
        CompletedTime
        ActionDomain
        ActionQuestion
        Action
        Frequency
        ActionNote
        Update1Points
        Update1Note
        Update1Date
        Update2Points
        Update2Note
        Update2Date
        Update3Points
        Update3Note
        Update3Date
        Update4Points
        Update4Note
        Update4Date
        Update5Points
        Update5Note
        Update5Date
        Update6Points
        Update6Note
        Update6Date
        Update7Points
        Update7Note
        Update7Date
        Update8Points
        Update8Note
        Update8Date
        Percentage
        Discontinued
        DiscontinuedDate
        Successful
        SuccessfulDate
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      organizationId
      __typename
    }
  }
`;
